export { default } from "./ScrollMobile";
export * from "./ScrollMobile";
